export * from './tipo-pratica.model';
export * from './pratica-dto.model';
export * from './configurazione.model';
export * from './pratica-utente.model';
export * from './pratica-dettaglio.model';
